import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import type { PopoverMenuTouchableOptionProps as Option } from 'modules/core/components/PopoverMenu'
import Popover from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  id: number
  isFixed: boolean | undefined
  canAssignEmployees: boolean
  hasFixedWorkSchedulesEnabled: boolean
}

const Settings = ({ id, isFixed, canAssignEmployees, hasFixedWorkSchedulesEnabled }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const popoverOptions = () => {
    const options: Option[] = []

    const assign: Option = {
      title: i18n.t('settings.work_schedule.table_data.popover.assign'),
      onClick: () => navigate(navigation.settings.workSchedule.id.employees.fullPath({ id })),
    }

    const edit: Option = {
      title: i18n.t('settings.work_schedule.table_data.popover.edit'),
      onClick: () => navigate(navigation.settings.workSchedule.id.edit.fullPath({ id })),
    }

    const archive: Option = {
      title: i18n.t('settings.work_schedule.table_data.popover.archive'),
      onClick: () => navigate(navigation.settings.workSchedule.id.archive.fullPath({ id })),
    }

    if (!canAssignEmployees) {
      options.push(edit, archive)

      return options
    }

    if (!hasFixedWorkSchedulesEnabled && isFixed) {
      options.push(archive)

      return options
    }

    options.push(assign, edit, archive)

    return options
  }

  return (
    <Popover type="list">
      <Popover.Trigger>
        <Button type="secondary" iconName="ellipsis" />
      </Popover.Trigger>
      <Popover.Content side="bottom" align="end">
        {popoverOptions().map((option, index) => {
          return (
            <Popover.TouchableOption key={index} onClick={option.onClick} title={option.title} />
          )
        })}
      </Popover.Content>
    </Popover>
  )
}

export default Settings
